// ═══════════════════════════════════════════════════════════════════════════
// filtrosCanal — el canal es un dato, también en la query del front
// ═══════════════════════════════════════════════════════════════════════════
//
// Las colecciones canónicas (`ordenes`, `publicaciones`, `campanas*`) son
// MULTI-CANAL: llevan `canal: 'mercado-libre' | 'tienda-nube' | …`. Un
// dashboard que no lo declara en su query no está "leyendo todo": está
// asumiendo que la empresa tiene un solo canal, y esa suposición dejó de ser
// cierta el día que Tienda Nube empezó a escribir las mismas colecciones.
//
// Qué pasaba sin esto (D0, 29-ago-2026): Velocidad de Consumo, Contribución
// Neta y Postventa leían `publicaciones` filtrando SÓLO por conexión — y el
// filtro de conexión sólo aparece con multicuenta ML (`useCuentaSeleccionada`
// lista cuentas de ML), así que una empresa con 1 cuenta ML + 1 tienda TN
// caía en "sin filtro". Las publicaciones de Tienda Nube entraban al
// dashboard de Mercado Libre, y como las ÓRDENES sí filtraban ML, entraban
// con cero ventas: Velocidad las marcaba stock muerto y Contribución producto
// sin rotación. Números inventados presentados como diagnóstico — y en
// Velocidad, además, exportables a una tarea.
//
// ⚠️ Este helper es el punto de anclaje, no una limpieza masiva. Al escribirlo
// había **20 call sites** con el literal `{ field: 'canal', … }` en tres formas
// distintas (inline, `const FILTRO_CANAL_ML` de archivo, `const CANAL` de
// módulo): o sea, ya se intentó consolidar dos veces y ninguna se propagó.
// Sólo se migran acá los sitios que D0 toca; el resto es deuda con ratchet.
// ═══════════════════════════════════════════════════════════════════════════

/** El canal por default de las pantallas de Mercado Libre. */
export const CANAL_ML = 'mercado-libre'

/**
 * Filtro de canal para `useDashboardData` / `useFacetCounts`.
 *
 * @param {string} canal — id del canal (`'mercado-libre'`, `'tienda-nube'`…)
 * @returns {{field: 'canal', op: '==', value: string}}
 */
export function filtroCanal(canal = CANAL_ML) {
  return { field: 'canal', op: '==', value: canal }
}

/**
 * Atajo para el caso más común. Congelado: se pasa a arrays de filtros que se
 * memoizan, y un objeto nuevo por render invalidaría la memo del consumidor.
 */
export const FILTRO_CANAL_ML = Object.freeze(filtroCanal(CANAL_ML))
